export default __webpack_public_path__ + "static/media/คืนยอดเทิร์น1ทุกวัน.129c9a2b.png";